import * as React from 'react';
import * as style from './style.css';
import { Link } from '../Link';
import { UIText1 } from '@cian/ui-kit';
import { EOffersClickAction } from '../../../../types/tracking';
import { TrackingContext } from '../../../../shared/context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var OffersLinks = function OffersLinks(_ref) {
  var linksInfo = _ref.linksInfo,
    houseId = _ref.houseId,
    roomType = _ref.roomType;
  var _React$useContext = React.useContext(TrackingContext),
    trackListingLinkClick = _React$useContext.trackListingLinkClick;
  var onDeveloperLinkClick = React.useCallback(function () {
    trackListingLinkClick(EOffersClickAction.fromDeveloper);
  }, [trackListingLinkClick]);
  var onAgentsLinkClick = React.useCallback(function () {
    trackListingLinkClick(EOffersClickAction.fromAgents);
  }, [trackListingLinkClick]);
  var onAllLinkClick = React.useCallback(function () {
    trackListingLinkClick(EOffersClickAction.fromAll);
  }, [trackListingLinkClick]);
  if (!linksInfo) {
    return null;
  }
  if (roomType.length > 0) {
    return /*#__PURE__*/_jsx("div", {
      className: style['container'],
      children: /*#__PURE__*/_jsx(UIText1, {
        children: /*#__PURE__*/_jsx(Link, {
          href: linksInfo.fromDeveloperPropsCountUrl,
          target: "_blank",
          onClick: onDeveloperLinkClick,
          children: "\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F"
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [linksInfo.fromAgentsPropsCountUrl && /*#__PURE__*/_jsxs(UIText1, {
      children: [/*#__PURE__*/_jsxs(Link, {
        href: linksInfo.fromAgentsPropsCountUrl,
        target: "_blank",
        onClick: onAgentsLinkClick,
        children: ["\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C ", linksInfo.fromAgentsPropsCountDisplay]
      }), ' ', "\u043E\u0442 \u0430\u0433\u0435\u043D\u0442\u043E\u0432 \u0438 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432"]
    }), linksInfo.fromAllPropsCountUrl && /*#__PURE__*/_jsxs(UIText1, {
      children: ["\u0412\u0441\u0435\u0433\u043E", ' ', /*#__PURE__*/_jsx(Link, {
        href: linksInfo.fromAllPropsCountUrl,
        target: "_blank",
        onClick: onAllLinkClick,
        children: linksInfo.fromAllPropsCountDisplay
      }), houseId ? ' в этом корпусе' : ' в ЖК']
    })]
  });
};